var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionRestricted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.1937 0 0 11.1937 0 25C0 38.8079 11.1937 50 25 50C38.8079 50 50 38.8095 50 25C50 11.1937 38.8077 0 25 0ZM25 45.3124C13.7813 45.3124 4.68758 36.2187 4.68758 25C4.68758 13.7813 13.7813 4.68758 25 4.68758C36.2187 4.68758 45.3124 13.7813 45.3124 25C45.3124 36.2187 36.2187 45.3124 25 45.3124ZM25.0016 10.964C23.211 10.964 21.8562 11.8985 21.8562 13.4078V27.2515C21.8562 28.7624 23.2108 29.6937 25.0016 29.6937C26.7484 29.6937 28.147 28.7234 28.147 27.2515V13.4078C28.1468 11.9343 26.7484 10.964 25.0016 10.964ZM25.0016 32.8125C23.2813 32.8125 21.8812 34.2126 21.8812 35.9343C21.8812 37.653 23.2813 39.0531 25.0016 39.0531C26.7219 39.0531 28.1204 37.653 28.1204 35.9343C28.1202 34.2124 26.7219 32.8125 25.0016 32.8125Z",
    fill: "#E2574C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionRestricted);
export default __webpack_public_path__ + "static/media/actionRestricted.21464be17935b1e0262c2ec66ea6c619.svg";
export { ForwardRef as ReactComponent };